// extracted by mini-css-extract-plugin
export default {"cta":"bjq7G"};